export enum BusinessTabsEnum {
  Caixa = 0,
  OrderTickets = 1,
  Clientes = 2,
  CashFlow = 3,
  Transactions = 4,
  Commissions = 5,
  Dashboard = 6,
  WhatsApp = 7,
  Information = 8,
  Services = 9,
  Products = 10,
  Packages = 11,
  Employees = 12,
  Admins = 13,
  Goals = 14,
  FinancialSettings = 15,
  Plan = 16,
  Campaigns = 17
}

export interface IBusinessTabConfig {
  label: string;
  icon: string;
  testId: string;
}

export const BUSINESS_TAB_CONFIG: Record<BusinessTabsEnum, IBusinessTabConfig> = {
  [BusinessTabsEnum.Caixa]: { label: 'Caixa', icon: 'account_balance_wallet', testId: 'tab-caixa' },
  [BusinessTabsEnum.OrderTickets]: { label: 'Comandas', icon: 'receipt', testId: 'tab-comandas' },
  [BusinessTabsEnum.Clientes]: { label: 'Clientes', icon: 'people', testId: 'tab-clientes' },
  [BusinessTabsEnum.CashFlow]: { label: 'Fluxo de Caixa', icon: 'auto_graph', testId: 'tab-fluxo-caixa' },
  [BusinessTabsEnum.Transactions]: { label: 'Entradas/Saídas', icon: 'swap_vert', testId: 'tab-entradas-saidas' },
  [BusinessTabsEnum.Commissions]: { label: 'Comissões', icon: 'percent', testId: 'tab-comissoes' },
  [BusinessTabsEnum.Dashboard]: { label: 'Dashboard', icon: 'bar_chart', testId: 'tab-dashboard' },
  [BusinessTabsEnum.WhatsApp]: { label: 'WhatsApp', icon: 'chat', testId: 'tab-whatsapp' },
  [BusinessTabsEnum.Information]: { label: 'Informações', icon: 'business', testId: 'tab-informacoes' },
  [BusinessTabsEnum.Services]: { label: 'Serviços', icon: 'build', testId: 'tab-servicos' },
  [BusinessTabsEnum.Products]: { label: 'Produtos', icon: 'shopping_cart', testId: 'tab-produtos' },
  [BusinessTabsEnum.Packages]: { label: 'Pacotes', icon: 'inventory_2', testId: 'tab-pacotes' },
  [BusinessTabsEnum.Employees]: { label: 'Profissionais', icon: 'person', testId: 'tab-profissionais' },
  [BusinessTabsEnum.Admins]: { label: 'Administradores', icon: 'engineering', testId: 'tab-admins' },
  [BusinessTabsEnum.Goals]: { label: 'Metas', icon: 'track_changes', testId: 'tab-metas' },
  [BusinessTabsEnum.FinancialSettings]: { label: 'Config. Financeiras', icon: 'attach_money', testId: 'tab-financial-settings' },
  [BusinessTabsEnum.Plan]: { label: 'Plano', icon: 'workspace_premium', testId: 'tab-plano' },
  [BusinessTabsEnum.Campaigns]: { label: 'Campanhas', icon: 'campaign', testId: 'tab-campanhas' },
};

export const ALL_BUSINESS_TABS: readonly BusinessTabsEnum[] = [
  BusinessTabsEnum.Caixa,
  BusinessTabsEnum.OrderTickets,
  BusinessTabsEnum.Clientes,
  BusinessTabsEnum.CashFlow,
  BusinessTabsEnum.Transactions,
  BusinessTabsEnum.Commissions,
  BusinessTabsEnum.Dashboard,
  BusinessTabsEnum.WhatsApp,
  BusinessTabsEnum.Information,
  BusinessTabsEnum.Services,
  BusinessTabsEnum.Products,
  BusinessTabsEnum.Packages,
  BusinessTabsEnum.Employees,
  BusinessTabsEnum.Admins,
  BusinessTabsEnum.Goals,
  BusinessTabsEnum.FinancialSettings,
  BusinessTabsEnum.Plan,
  BusinessTabsEnum.Campaigns,
];

// Tabs permitidas para receptionist
export const RECEPTIONIST_TABS = new Set([
  BusinessTabsEnum.Caixa,
  BusinessTabsEnum.OrderTickets,
  BusinessTabsEnum.Clientes,
  BusinessTabsEnum.Transactions,
  BusinessTabsEnum.Dashboard,
  BusinessTabsEnum.Goals,
]);

// Feature gate: tab indices blocked per feature code
export const FEATURE_TAB_GATES: Record<string, BusinessTabsEnum[]> = {
  cash_flow: [BusinessTabsEnum.CashFlow],
  commissions: [BusinessTabsEnum.Commissions, BusinessTabsEnum.Goals],
  whatsapp_ai: [BusinessTabsEnum.WhatsApp],
  campaigns: [BusinessTabsEnum.Campaigns],
};
